




















































import { AreaItem } from '@tt4b/ttam-enums';
import { computed, defineComponent, PropType } from '@vue/composition-api';
import TooltipInfo from '@/components/common/tooltip-info/index.vue';

const name = 'ttam-location';
export default defineComponent({
  name,
  components: {
    TooltipInfo,
  },
  props: {
    value: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    isSupportBrandSafety: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    treeData: {
      type: Array as PropType<AreaItem[]>,
      default: () => [{ value: 'went inside default here' }],
    },
    treeProps: {
      type: Object,
      default: () => ({ label: 'label', tagLabel: 'label', children: 'children' }),
    },
  },
  setup(props, { emit }) {
    const _particleLocations = computed({
      get: () => props.value,
      set: val => {
        emit('input', val);
        emit('change', val);
      },
    });
    const onLocationChange = (val, nodes, node, isChecked, xx) => {
      emit('location-change', val, nodes, node, isChecked);
    };
    const onClearAll = () => {
      emit('close-all');
    };
    return {
      name,
      _particleLocations,
      onLocationChange,
      onClearAll,
    };
  },
});
